export class InsertSuggestionEvent {
    readonly suggestion: string;
    defaultPrevented: boolean = false;
    constructor(suggestion: string) {
        this.suggestion = suggestion;
    }

    preventDefault(): void {
        this.defaultPrevented = true;
    }
}